import { InvoiceDownloadAPI } from '../../models/invoices/invoice-download-api';
import {
  GET_INVOICES,
  GET_INVOICES_SUCCESS,
  InvoicesAction,
  SORT_INVOICES_COMPLETED,
  SORT_INVOICES_INIT,
  GET_INVOICES_ERROR
} from '../../actions/invoices/actions-invoices';
import { Sorting } from '../../models/invoices/invoices.model';

export const INVOICES_REDUCER = 'invoicesReducer';

export interface InvoicesState {
  isLoading: boolean;
  loadingError: string;
  sorting: Sorting;
  invoices: InvoiceDownloadAPI.IInvoiceResponse[];
}

export const invoicesInitState: InvoicesState = {
  isLoading: true,
  loadingError: '',
  sorting: Sorting.asc,
  invoices: []
};

/* eslint-disable */
export function reducersInvoices(state = invoicesInitState, action: InvoicesAction): InvoicesState {
  switch (action.type) {
    case GET_INVOICES:
      return { ...state, isLoading: true, loadingError: '' };

    case GET_INVOICES_SUCCESS:
      state = { ...state, isLoading: false, loadingError: '' };
      state.sorting = Sorting.asc;
      state.invoices = action.payload;
      return state;

    case GET_INVOICES_ERROR:
      return { ...state, isLoading: false, loadingError: action.payload };

    case SORT_INVOICES_INIT:
      state = { ...state, isLoading: true, loadingError: '' };
      state.sorting = action.payload;
      return state;

    case SORT_INVOICES_COMPLETED:
      state = { ...state, isLoading: false, loadingError: '' };
      state.invoices = action.payload;
      return state;

    default:
      return state;
  }
}
